import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import NutritionSodiumPotassiumCombined from "./index";

const NutritionSodiumPotassiumWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={NutritionSodiumPotassiumCombined}
    keyControlsId="nutrition-sodium-potassium-key"
    {...props}
  />
);

export default NutritionSodiumPotassiumWithToggleKey;
